import { Theme } from "@mui/material/styles";

// ----------------------------------------------------------------------

export const TabPanel = (theme: Theme) => {
  return {
    MuiTabPanel: {
      styleOverrides: {
        root: {
          paddingRight: "0px",
          paddingLeft: "0px", 
        },
      },
    },
  };
};
